import clsx from 'clsx';
import { TransparentButton, Heading, Paragraph } from '@hungryroot/ui-kit';
import { OrdersTab } from '../types';

import styles from './OrdersTabBar.module.css';

interface TabConfig {
  id: OrdersTab;
  label: string;
  iconSrc: string;
}

const TABS: ReadonlyArray<TabConfig> = [
  {
    id: OrdersTab.Cart,
    label: 'Cart',
    iconSrc: '/public/img/orders/cart.png',
  },
  {
    id: OrdersTab.OnTheWay,
    label: 'In transit',
    iconSrc: '/public/img/orders/on-the-way.png',
  },
  {
    id: OrdersTab.Upcoming,
    label: 'Upcoming',
    iconSrc: '/public/img/orders/upcoming.png',
  },
  {
    id: OrdersTab.Delivered,
    label: 'Delivered',
    iconSrc: '/public/img/orders/delivered.png',
  },
];

interface Props {
  activeTab: OrdersTab;
  onTabChange: (tab: OrdersTab) => void;
  testid?: string;
}

/**
 * All four tabs share the row width so they fit on screen without horizontal
 * scrolling. The active tab gets a larger icon, a heavier label, and an
 * underline; inactive tabs keep a smaller icon with secondary-color copy.
 */
export function OrdersTabBar(props: Props) {
  const { activeTab, onTabChange, testid } = props;

  return (
    <div className={styles.container} data-testid={testid ?? 'orders-tab-bar'}>
      {TABS.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <TransparentButton
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            ariaLabel={tab.label}
            testid={`orders-tab-${tab.id}`}
            className={clsx(styles.tab, {
              [styles['tab-active']]: isActive,
            })}
          >
            <span className={styles['icon-wrap']} aria-hidden="true">
              <img
                className={clsx(styles.icon, {
                  [styles['icon-active']]: isActive,
                })}
                src={tab.iconSrc}
                alt=""
              />
            </span>
            {isActive ? (
              <Heading variant="H6" className={styles.label}>
                {tab.label}
              </Heading>
            ) : (
              <Paragraph
                as="span"
                variant="body"
                className={clsx(styles.label, styles['label-inactive'])}
              >
                {tab.label}
              </Paragraph>
            )}
          </TransparentButton>
        );
      })}
    </div>
  );
}
